import * as designTokens from './border';

export const border = {
  ...designTokens,
};
